import { AlertType } from '@features/researches/models/alert.model';

export interface ResearchesSort {
  sortBy: SortType;
  sortOrder: SortOrder;
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SortType {
  ID = 'ID',
  START = 'START',
  END = 'END',
  COMPANY = 'COMPANY',
  NAME = 'NAME',
  CREATED = 'CREATED',
  MODIFIED = 'MODIFIED'
}

export interface RequestData {
  sortOrder?: SortOrder;
  searchText?: string;
  sortBy?: SortType;
}

export interface AlertsFilters {
  searchText?: string;
  alertType?: AlertType[];
  researchName?: string[];
  alertDate?: string;
}

export interface AlertsRequestData extends AlertsFilters {
  pageNo: number;
  pageSize: number;
}

export interface SensorsFilters {
  seatId?: string;
  alertType?: AlertType[];
  researchName?: string[];
}

export enum SensorsSortType {
  RSSI = 'RSSI',
  BATTERY = 'BATTERY',
  ID = 'ID',
  SEAT = 'SEAT'
}

export interface SensorsRequestData extends SensorsFilters {
  sort?: SensorsSort;
  pageNo: number;
  pageSize: number;
}
export interface SensorsSort {
  sortBy?: SensorsSortType;
  sortOrder?: SortOrder;
}

export interface FetchSensorsRequest {
  sort?: SensorsSort;
  loadMoreSensors: boolean;
}

export const PAGE_SIZE = 20;
